import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { SitesService, Co2CostResponse } from 'src/app/services/sites.service';
import { UtilisateurService } from 'src/app/services/utilisateur.service';
import { ProductSourcesService } from 'src/app/services/product-sources.service';
import { HttpService } from 'src/app/services/http.service';
import { Warehouse } from 'src/app/bo/warehouse';
import { Factory } from 'src/app/bo/factory';
import { ProductCost } from 'src/app/bo/products/product-cost';
import { Equipment } from 'src/app/bo/equipment';
import { Blast } from 'src/app/services/hole.service';
import { Co2CalculatorService, Co2BlastSummary } from './co2-calculator.service';
import { Site } from 'src/app/bo/site';

@Injectable({
  providedIn: 'root'
})
export class BlastEnvironmentService {

  private co2Costs: Co2CostResponse[] = [];
  private productCosts: ProductCost[] = [];
  private warehouses: Warehouse[] = [];
  private factories: Factory[] = [];
  private equipments: Equipment[] = [];

  constructor(
    private readonly sitesService: SitesService,
    private readonly utilisateurService: UtilisateurService,
    private readonly productSourcesService: ProductSourcesService,
    private readonly httpService: HttpService,
    private readonly co2Calculator: Co2CalculatorService
  ) {}

  async loadData(): Promise<void> {
    const currentSite:Site = this.utilisateurService.currentSite();
    const siteId = currentSite?.siteId;
    const regionId = currentSite?.regionId;
    const orgId = currentSite?.orgId || currentSite?.region?.orgId;

    if (!siteId) return;

    this.co2Costs = await firstValueFrom(this.sitesService.getCo2CostsBySite(siteId)) || [];

    if (regionId) {
      this.productCosts = await firstValueFrom(this.sitesService.getProductCosts(regionId, siteId)) || [];
      const co2Map = new Map(this.co2Costs.map(c => [c.productId, c]));
      this.productCosts.forEach(product => {
        const co2 = co2Map.get(product.productId);
        if (co2) {
          product.co2CostId = co2.co2CostId;
          product.warehouseId = co2.warehouseId;
        }
      });
    }

    if (orgId) {
      this.warehouses = await firstValueFrom(this.productSourcesService.getWarehouses(orgId)) || [];
      this.factories = await firstValueFrom(this.productSourcesService.getFactories(orgId)) || [];
    }

    this.equipments = await firstValueFrom(this.httpService.get<Equipment[]>(`Sites/${siteId}/Equipment`)) || [];
  }

  calculateSummary(blast: Blast): Co2BlastSummary | null {
    if (!blast?.Holes || !this.warehouses.length || !this.productCosts.length) {
      return null;
    }

    const currentSite:Site = this.utilisateurService.currentSite();

    return this.co2Calculator.calculateSummary({
      blast,
      productCosts: this.productCosts,
      co2Costs: this.co2Costs,
      warehouses: this.warehouses,
      factories: this.factories,
      equipments: this.equipments,
      siteCoordY: currentSite?.coordY,
      siteCoordX: currentSite?.coordX
    });
  }
}
